import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaGraduationCap } from "react-icons/fa";
import { loginAdmin } from "../../utils/admin";

const AdminLogin = () => {
    const [credentials, setCredentials] = useState({ email: "", password: "" });
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false); // New loading state
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setCredentials((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true); // start loading

        try {
            const response = await loginAdmin(credentials);
            if (response.token) {
                localStorage.setItem("token", response.token);
                // Backend returns { token, admin } — keep "user" for backwards-compat
                // and add "admin" so the dashboard greeting picks it up.
                const profile = response.admin || response.user;
                if (profile) {
                    localStorage.setItem("user", JSON.stringify(profile));
                    localStorage.setItem("admin", JSON.stringify(profile));
                }
                navigate("/dashboard");
            } else {
                setError(response.message || "Login failed. Please try again.");
            }
        } catch (error) {
            setError("An error occurred. Please try again.");
        } finally {
            setLoading(false); // stop loading
        }
    };

    return (
        <div className="relative min-h-screen bg-gradient-to-br from-[#2148C0] via-[#1B45BF] to-[#0F2669] flex items-center justify-center px-4 overflow-hidden">
            <div className="absolute -top-40 -right-40 w-80 h-80 bg-purple-500 rounded-full mix-blend-screen filter blur-3xl opacity-30 animate-pulse" />
            <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-blue-300 rounded-full mix-blend-screen filter blur-3xl opacity-25 animate-pulse animation-delay-2000" />
            <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-60 h-60 bg-[#FFD700] rounded-full mix-blend-screen filter blur-3xl opacity-20 animate-pulse animation-delay-4000" />

            <form
                onSubmit={handleSubmit}
                className="relative z-10 bg-white/95 backdrop-blur-sm p-8 rounded-2xl shadow-2xl shadow-[#0B1D50]/40 w-full max-w-md border border-white/40"
            >
                <div className="flex flex-col items-center mb-6">
                    <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-[#2148C0] to-blue-500 text-white shadow-lg shadow-[#2148C0]/30 mb-3">
                        <FaGraduationCap className="text-2xl" />
                    </div>
                    <h1 className="text-2xl font-bold text-gray-900">Welcome back</h1>
                    <p className="text-sm text-gray-500 mt-1">
                        Sign in to the TeeChaa Admin Console
                    </p>
                </div>

                {error && (
                    <div className="mb-4 rounded-xl border border-red-200 bg-red-50 px-4 py-2.5 text-red-700 text-sm">
                        {error}
                    </div>
                )}

                <div className="mb-4">
                    <label className="block mb-1.5 text-sm font-medium text-gray-700">
                        Email
                    </label>
                    <input
                        type="email"
                        name="email"
                        value={credentials.email}
                        onChange={handleChange}
                        className="w-full border border-gray-200 px-4 py-2.5 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#2148C0]/30 focus:border-[#2148C0]"
                        placeholder="you@teechaa.com"
                        required
                        disabled={loading}
                    />
                </div>
                <div className="mb-6">
                    <label className="block mb-1.5 text-sm font-medium text-gray-700">
                        Password
                    </label>
                    <input
                        type="password"
                        name="password"
                        value={credentials.password}
                        onChange={handleChange}
                        className="w-full border border-gray-200 px-4 py-2.5 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#2148C0]/30 focus:border-[#2148C0]"
                        placeholder="••••••••"
                        required
                        disabled={loading}
                    />
                </div>
                <button
                    type="submit"
                    className="w-full bg-[#2148C0] hover:bg-blue-700 disabled:opacity-60 text-white py-2.5 rounded-xl font-semibold flex justify-center items-center shadow-lg shadow-[#2148C0]/20 transition-colors"
                    disabled={loading}
                >
                    {loading ? (
                        <svg
                            className="animate-spin h-5 w-5 text-white"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                        >
                            <circle
                                className="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                strokeWidth="4"
                            />
                            <path
                                className="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                            />
                        </svg>
                    ) : (
                        "Sign in"
                    )}
                </button>
            </form>
        </div>
    );
};

export default AdminLogin;
